// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/movimenti-magazzino/:id',
    requestBody: null,
    response: '{ success: true, data: Testata + righe, logs: [...] }'
  },
  {
    method: 'PUT',
    endpoint: '/api/movimenti-magazzino/:id',
    requestBody: '{ data, descrizione, numeroDocumentoEsterno, dataDocumentoEsterno, note }',
    response: '{ success: true, data: { id } }'
  },
  {
    method: 'GET',
    endpoint: '/api/movimenti-magazzino/lookup/articoli?societaId=&q=&depositoId=',
    requestBody: null,
    response: '{ success: true, data: [{ id, codice, descrizioneBase, tipologia, umVendita, prezzoStandard, giacenzaDeposito }] }'
  },
  {
    method: 'POST',
    endpoint: '/api/movimenti-magazzino/:id/righe',
    requestBody: '{ articoloId, quantita, prezzoUnitario, segno, note }',
    response: '{ success: true, data: { id, ordine } }'
  },
  {
    method: 'PUT',
    endpoint: '/api/movimenti-magazzino/:id/righe/:rigaId',
    requestBody: '{ quantita, prezzoUnitario, segno, note }',
    response: '{ success: true }'
  },
  {
    method: 'DELETE',
    endpoint: '/api/movimenti-magazzino/:id/righe/:rigaId',
    requestBody: null,
    response: '{ success: true }'
  },
  {
    method: 'POST',
    endpoint: '/api/movimenti-magazzino/:id/conferma',
    requestBody: null,
    response: '{ success: true, data: { id, numero, anno } }'
  },
  {
    method: 'POST',
    endpoint: '/api/movimenti-magazzino/:id/storna',
    requestBody: '{ data, motivo }',
    response: '{ success: true, data: { id, numero, anno } }'
  },
  {
    method: 'DELETE',
    endpoint: '/api/movimenti-magazzino/:id',
    requestBody: null,
    response: '{ success: true }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
